import restService from "./rest.service";

export default class CadastroService {
    static async pacienteExistenteRecadastro(params) {
        return await restService.postAsync("cadastro/LoginDesambiguar", params);
    }
}
